"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var BusinessClimb = function BusinessClimb(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-1201.000000, -3001.000000)",
    stroke: fill,
    strokeWidth: "2.25"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(1203.000000, 3003.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.46527778,21.9170833 L11.7291667,8.79208333 C11.961213,8.49001567 12.3204816,8.31296574 12.7013889,8.31296574 C13.0822962,8.31296574 13.4415647,8.49001567 13.6736111,8.79208333 L21.9375,21.9170833 L3.46527778,21.9170833 Z"
  }), /*#__PURE__*/_react["default"].createElement("polyline", {
    points: "3.46527778 21.9170833 0.0625 21.9170833 3.70833333 15.3545833 5.82291667 18.1730556"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.79166667,15.0463889 L10.0744444,16.9645833 C10.4603675,17.291242 11.0322523,17.2675719 11.3898611,16.9101389 L12.0140278,16.285 C12.3936804,15.905462 13.0090974,15.905462 13.38875,16.285 L14.0129167,16.9101389 C14.3705255,17.2675719 14.9424103,17.291242 15.3283333,16.9645833 L17.6111111,15.0463889"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "12.4583333",
    y1: "8.34291667",
    x2: "12.4583333",
    y2: "0.0420833333"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.4583333,0.0420833333 L19.4515278,0.0420833333 C19.6463733,0.0430719385 19.8230216,0.156793995 19.9045833,0.33375 C19.9885264,0.510609366 19.9647817,0.719788662 19.8433333,0.873333333 L18.7379167,2.27527778 C18.591248,2.46257351 18.591248,2.72575983 18.7379167,2.91305556 L19.8472222,4.31694444 C19.968622,4.47088299 19.992351,4.68030148 19.9084722,4.8575 C19.8271,5.0346206 19.6503335,5.14841875 19.4554167,5.14916667 L12.4583333,5.14916667"
  })))));
};
BusinessClimb.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
BusinessClimb.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = BusinessClimb;